import { useLanguageContext } from "../../../context/LanguageContext";
import UserPage from "../../../pages/users/user/UserPage";
import { useUserCreateRouteValidator } from "../../validators/users/UserCreateRouteValidator";
import { RouteConfig } from "../RouteConfig";
import useUsersRouteConfig from "./UsersRouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useUserCreateRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/users/create")
    .setLabel(
      translate("eva.main.entities.states.create", [
        {
          key: "entities",
          value: translate("eva.main.entities.user"),
        },
      ])
    )
    .setValidator(useUserCreateRouteValidator())
    .setPage(<UserPage />)
    .setParent(useUsersRouteConfig());
}

export default useUserCreateRouteConfig;
